// useNow.js
// A clock for labels computed from "now" — "just now", "14m ago", "Today",
// "Yesterday". Such a label is computed at render, so unless something else
// re-renders the host it stays as it was when it was drawn: "just now" for an
// hour, "Today" all of tomorrow. A host that calls this re-renders on a steady
// cadence instead, so no label is more than one tick behind its boundary,
// local midnight included. Returns the current time in milliseconds.

import { useEffect, useState } from 'react';

export const NOW_TICK_MS = 30 * 1000;

export default function useNow(intervalMs = NOW_TICK_MS) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
